import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CountdownComponent } from '@modules/common/components/countdown/countdown.component';
import { SessionExpirationDialogArgs } from '@modules/common/models/session-expiration-dialog-args';
import { SessionExpirationDialogResult } from '@modules/common/models/session-expiration-dialog-result';
import { UserSessionService } from '@modules/common/services/user-session.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-session-expiration-dialog',
    templateUrl: './session-expiration-dialog.component.html',
    styleUrls: ['./session-expiration-dialog.component.scss']
})
export class SessionExpirationDialogComponent implements OnInit, OnDestroy {
    @ViewChild(CountdownComponent, { static: true })
    public countdownComponent!: CountdownComponent;

    private _userSessionChangedSubscription?: Subscription;

    constructor(
        private _dialogRef: MatDialogRef<SessionExpirationDialogComponent, SessionExpirationDialogResult>,
        @Inject(MAT_DIALOG_DATA) private _args: SessionExpirationDialogArgs,
        private _userSessionService: UserSessionService
    ) {}

    public ngOnInit(): void {
        this.countdownComponent.countdownTo(this._args.expirationDate);
        this._userSessionChangedSubscription = this._userSessionService.userSessionChanged().subscribe(result => {
            if (result && result.authenticationToken && result.authenticationToken!.token != this._args.token) {
                this._dialogRef.close();
            }
        })
    }

    public ngOnDestroy(): void {
        if (this._userSessionChangedSubscription) {
            this._userSessionChangedSubscription.unsubscribe();
        }
    }

    public signOut() {
        this._dialogRef.close({
            action: 'signOut',
            clearRedirectedFromUrl: true
        });
    }

    public refreshSession() {
        this._dialogRef.close({
            action: 'refresh'
        });
    }

    public expire() {
        this._dialogRef.close({
            action: 'signOut',
            clearRedirectedFromUrl: false
        });
    }
}
